import { apiUrl } from './helper';

export const resolveImageUrl = (src) => {
    if (!src) return '';

    if (src.startsWith('http://') || src.startsWith('https://')) {
        return src;
    }

    if (src.startsWith('/api/images/')) {
        return `${apiUrl}${src}`;
    }

    if (src.startsWith('/assets/img/')) {
        const fileName = src.replace('/assets/img/', '');
        return `${apiUrl}/api/images/${fileName}`;
    }

    if (src.startsWith('/')) {
        return `${apiUrl}${src}`;
    }

    return `${apiUrl}/${src}`;
};
